import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { ArrowForward } from '@mui/icons-material';

// Import your images
import Insightimage1 from '../images/homepage/blog1.png'; // adjust paths as needed
import Insightimage2 from '../images/homepage/blog2.png';
import Insightimage3 from '../images/homepage/blog3.png';

// Slick carousel CSS (make sure these are installed in your project)
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Insightdata = [
  {
    Insighttitle: 'Why Your Service Business Has Outgrown Spreadsheets?',
    Insightdesc: 'Discover smarter ways to manage operations and reduce manual work.',
    Insightdate: (
    <>
     <ul> Jane Watson <li>April 22, 2025</li> </ul>
    </>
    ),
    InsightImage: Insightimage1,
    link: '/insights/top-tools-hvac-techs-use',
  },
  {
    Insighttitle: 'How Centralized Tools Boost Team Productivity?',
    Insightdesc: 'Learn why putting everything in one place leads to better performance.',
     Insightdate: (
    <>
     <ul> Jane Watson <li>April 22, 2025</li> </ul>
    </>
    ),
    InsightImage: Insightimage2,
    link: '/insights/top-tools-hvac-techs-use',
  },
  {
    Insighttitle: 'Top Features Every Service Business Needs To Know.',
    Insightdesc: 'Don’t miss these essential tools for smoother, more efficient operations.',
    Insightdate: (
    <>
      <ul> Jane Watson <li>April 22, 2025</li> </ul>
    </>
    ),
    InsightImage: Insightimage3,
    link: '/insights/top-tools-hvac-techs-use',
  },
];

const InsightSection = () => {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Section>
      <h2>
        <span>Insights for Smarter</span>  Service Management
      </h2>
      <p>Stay ahead of the curve with actionable tips, best practices, and expert advice to optimize your service business operations.</p>

      <DesktopView>
        <InsightGrid>
          {Insightdata.map((item, index) => (
            <Card key={index}>
              <img src={item.InsightImage} alt={item.Insighttitle} />
              <small>{item.Insightdate}</small>
              <h3>{item.Insighttitle}</h3>
              <p>{item.Insightdesc}</p>
              <a href={item.link} style={{ color: '#4F46E5', textDecoration: 'underline', marginTop: '10px', display: 'inline-block' }} > Read More  <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle', fill: '#4F46E5' }} /></a>
            </Card>
          ))}
        </InsightGrid>
      </DesktopView>

      <MobileView>
        <Slider {...sliderSettings}>
          {Insightdata.map((item, index) => (
            <Card key={index}>
              <img src={item.InsightImage} alt={item.Insighttitle} />
              <small>{item.Insightdate}</small>
              <h3>{item.Insighttitle}</h3>
              <p>{item.Insightdesc}</p>
              <a href={item.link} style={{ color: '#4F46E5', textDecoration: 'underline', marginTop: '10px', display: 'inline-block' }}>  Read More</a>
              
            </Card>
          ))}
        </Slider>
      </MobileView>
    </Section>
  );
};

export default InsightSection;

// Styled Components
const Section = styled.section`
  padding: 5rem 7rem;
  text-align: center;

  @media screen and (max-width: 700px) {
    padding: 5rem 0rem;
  }
    @media screen and (min-width: 701px) and (max-width: 1100px) {
        padding: 5rem 2rem !important;
    }

  h2 {
    font-size: 40px;
    margin-bottom: 10px;
    padding: 0 29% !important;

    @media screen and (max-width: 700px) {
      padding: 0 0% !important;
       font-size: 30px;
  }
       @media screen and (min-width: 701px) and (max-width: 1100px) {
        padding: 0 0% !important;
    }

    span {
    background: linear-gradient(to right, #DD8FF9 0%, #A975FE 33%, #4F46E5 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
  }

  p {
    font-size: 14px;
    font-weight: 400 !important;
    text-align: center;
    padding: 0 30%;
    color: #5B5B5B !important;

    @media screen and (max-width: 700px) {
      padding: 0 0% !important;
  }
      @media screen and (min-width: 701px) and (max-width: 1100px) {
        padding: 0 0% !important;
        text-align: center !important;
    }
  }
`;

const InsightGrid = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 90px 0 0 0;
`;

const Card = styled.div`
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  text-align: left;
  width: 33%;
  flex: 0 0 33%;
  margin: 0 auto;

  img {
    width: 100%;
    border-radius: 6px;
    margin-bottom: 15px;
  }

  h3 {
    margin-top: 0;
    font-size: 18px;
    color: #111;
    padding: 0 50px 0 10px;
  }

  @media screen and (min-width: 701px) and (max-width: 1100px) {
    padding: 0px !important;
    }

  p {
    font-size: 14px;
    color: #444;
    text-align: left;
    padding: 10px;

    @media screen and (max-width: 700px) {
      padding: 10px !important;
  }

  @media screen and (min-width: 701px) and (max-width: 1100px) {
    text-align: left !important;
    }
  }
    a{
     padding: 10px;
     font-weight: 500;
    }

  small {
    display: block;
    margin-top: 10px;
    color: #888;

    ul {
    display: flex;
    align-items: anchor-center;
    gap: 15px;
    font-size: 14px;
    color: #5B5B5B;
    font-family: 'Poppins';
    padding: 0px 10px;
    margin-bottom: 10px;

    li{
    align-items: anchor-center;
    }

    li:before {
    content: '';
    background: #5B5B5B !important;
    width: 5px;
    height: 5px;
    border-radius: 50px;
    margin-right:10px;
    
}
}
  }
`;

const DesktopView = styled.div`
  display: block;

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileView = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;
